import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { downloadFile } from "../utils/downloadFile";

const downloadTestSuiteResult = async (id, downloadType) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const downloadUrl = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=downloadTestSuiteResults&companyid=${user.companyid}&suiteresultid=${id}&type=${downloadType}`;

  await downloadFile(downloadUrl, { filename: `test_suite_results_${id}` });
};

const useDownloadTestSuiteQuery = (id, downloadType) => {
  return useQuery({
    queryKey: ["downloadtestSuiteResult", id, downloadType],
    queryFn: () => downloadTestSuiteResult(id, downloadType),
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useDownloadTestSuiteQuery;
